import { render, staticRenderFns } from "./Blade5b.vue?vue&type=template&id=08c3a6ab"
import script from "./Blade5b.vue?vue&type=script&lang=js"
export * from "./Blade5b.vue?vue&type=script&lang=js"
import style0 from "./Blade5b.vue?vue&type=style&index=0&id=08c3a6ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports